export default __webpack_public_path__ + "static/media/about-team-01.c0f51fee.jpg";